<template>
    <section :class="css.container" ref="container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("DiseaseCharacterization") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/0651e292-7d51-4b91-93b8-5a7ec99aa45f.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("DiseaseCharacterizationDesc1") }}</div>
                        <div :class="css_normalize.indexs">
                            <div :class="css_normalize.index">{{ $t("DiseaseCharacterizationDesc2") }}</div>
                            <div :class="css_normalize.index">{{ $t("DiseaseCharacterizationDesc3") }}</div>
                            <div :class="css_normalize.index">{{ $t("DiseaseCharacterizationDesc4") }}</div>
                        </div>
                        <div :class="css_normalize.context">{{ $t("DiseaseCharacterizationDesc5") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.not" class="container text-hint" v-if="!exist">{{ $t("Placeholder.NotModuleDescript") }}</div>
        <div :class="css.body" class="container" v-loading="loading" v-else>
            <ui-table2 :option="options.view" :data="data" @sort="methods.sort" :error="$t('NoDataAvailable')">
                <template #classification_extra>
                    <!-- * 全选按钮 -->
                    <ui-checkbox v-model="classification" :class="css_normalize.checkbox" value="all" @change="methods.classification">
                        {{ $t("SelectAll") }}
                    </ui-checkbox>
                    <!-- * 多选列表 -->
                    <ui-checkbox-group v-model="classifications" @change="methods.classifications" :class="css.checkbox_group">
                        <template v-for="value in filters">
                            <ui-checkbox :class="css_normalize.checkbox" :value="value.value">{{ value.label }}</ui-checkbox>
                        </template>
                    </ui-checkbox-group>
                </template>
                <template #index="{ data }">
                    {{ (page - 1) * 10 + data.index + 1 }}
                </template>
                <template #source="{ data }">
                    <template v-if="!data?.source">--</template>
                    <template v-else>
                        <project-route :class="css_normalize.assets" :to="`https://hpo.jax.org/app/browse/term/${data?.source}`">
                            {{ data?.source }}
                        </project-route>
                    </template>
                </template>
            </ui-table2>

            <ui-pagination v-model="page" :class="css.pagination" :count="count" :limit="10" @change="methods.acquire()">
                <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
            </ui-pagination>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiCheckbox, UiCheckboxGroup, UiPagination, UiTooltip } from "various-ui";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";

//* 组件属性注册
defineProps(ModulePropsOption);
//* 组合函数
const { refs, nodes, methods, options } = useComposable();
const { loading, exist, data, page, count, classification, classifications, filters } = refs;
const { container } = nodes;
const { render, hidden } = methods;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
